import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { BenefitTypeEnum } from "v2/domain/common/entities/BenefitType";
import BenefitCard from "../BenefitCard";
import gymImageDisabledV2 from "../../../../assets/img/v2/gym-disabled.png";
import gymImageV2 from "../../../../assets/img/v2/gym.png";

// eslint-disable-next-line no-shadow
export enum EBenefitStatus {
  REQUESTABLE = "requestable",
  REQUESTED = "requested",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

const BenefitGym = ({
  companyGymBenefit,
  modelGymBenefit,
  country,
  modelId,
}: {
  companyGymBenefit?: any;
  modelGymBenefit: boolean;
  country: string;
  modelId: string;
}) => {
  const [status, setStatus] = useState<EBenefitStatus>();
  const { t } = useTranslation();

  const getBadgeStatus = () => {
    if (status === EBenefitStatus.REQUESTABLE) {
      return "novelty";
    }
    if (status === EBenefitStatus.REQUESTED) {
      return "processing";
    }
    return undefined;
  };

  const gymBenefitConfig = {
    badgeStatus: getBadgeStatus(),
    hasV2Screen: status !== EBenefitStatus.REQUESTED,
    requested: status === EBenefitStatus.REQUESTED,
    requestInfo: status === EBenefitStatus.REQUESTABLE,
    image: status === EBenefitStatus.ACTIVE ? gymImageV2 : gymImageDisabledV2,
    active: status === EBenefitStatus.ACTIVE,
  };

  const navigateToBenefitInformationDetail = async () => {
    window.location.assign(
      `/v2/benefits/compensation-plan/${modelId}/gym?tab=information`
    );
  };

  const gymBenefitStatusMachine = useCallback(() => {
    if (!companyGymBenefit) {
      setStatus(EBenefitStatus.REQUESTABLE);
    }
    if (
      companyGymBenefit &&
      !companyGymBenefit.enabled &&
      companyGymBenefit.informationRequestedAt
    ) {
      setStatus(EBenefitStatus.REQUESTED);
    }
    if (companyGymBenefit?.enabled && !modelGymBenefit) {
      setStatus(EBenefitStatus.INACTIVE);
    }
    if (companyGymBenefit?.enabled && modelGymBenefit) {
      setStatus(EBenefitStatus.ACTIVE);
    }
  }, [companyGymBenefit, modelGymBenefit]);

  useEffect(() => {
    gymBenefitStatusMachine();
  }, [gymBenefitStatusMachine, companyGymBenefit, modelGymBenefit]);

  return (
    <BenefitCard
      benefit={BenefitTypeEnum.GYM_BENEFIT}
      title={t("gym.gyms")}
      active={gymBenefitConfig.active}
      image={gymBenefitConfig.image}
      country={country}
      isV2Benefit
      requestInfo={gymBenefitConfig.requestInfo}
      requested={gymBenefitConfig.requested}
      handleSeeMore={() =>
        window.location.assign(
          `/v2/benefits/compensation-plan/${modelId}/gym?tab=${
            gymBenefitConfig.active ? "settings" : "information"
          }`
        )
      }
      requestInfoButtonAction={navigateToBenefitInformationDetail}
      badgeStatus={gymBenefitConfig.badgeStatus}
      hasV2Screen={gymBenefitConfig.hasV2Screen}
      requestedButtonAction={navigateToBenefitInformationDetail}
    />
  );
};

export default BenefitGym;
